import './amplify-config'; // Must be first - configures Amplify before any service usage
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { SidebarProvider } from './contexts';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <HelmetProvider>
    <SidebarProvider>
      <App />
    </SidebarProvider>
  </HelmetProvider>
);
